import PromisedResource from './PromisedResource'

export default class VendorsResource extends PromisedResource {
  constructor({ remote, client }) {
    super(remote.query(q => client ? q.findRelatedRecords(client, 'vendors') : q.findRecords('vendor')))
  }
}
